import { Component } from '@angular/core';

@Component({
  selector: 'metodoDeTrabajo',
  templateUrl: './metodoDeTrabajo.component.html',
  styleUrls: ['./metodoDeTrabajo.component.css']
})
export class MetodoDeTrabajoComponent {
}
